import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MainContainer } from "../../components/layout";
import AdminDashboardGrid from "../../components/admin/dashboard/AdminDashboardGrid";
import UserContext from "../../state/UserContext";
import { useNavigate } from "react-router-dom";
import adminHelper from "../../helpers/adminHelper";
import AppContext from "../../state/AppContext";
import AppRoutes from "../AppRoutes";
import { faGears } from "@fortawesome/pro-regular-svg-icons";

function AdminDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const appContext = useContext(AppContext);

  useEffect(() => {
    if (!adminHelper.hasVisibleAdminDashboardCards(userContext)) {
      navigate(AppRoutes.yourJourney.root);
    }

    appContext.setPageTitle(
      t("Pages.Admin.Dashboard.PageTitle", "Admin: Dashboard"),
    );
    appContext.setShowPageTitleAccent(true);
    appContext.setPageIcon(faGears);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainContainer>
      <AdminDashboardGrid />
    </MainContainer>
  );
}

export default AdminDashboard;
